module.exports = __webpack_public_path__ + "static/assets/24631146b84d37efeccb7af83c467659.png";